import { useEffect, useState } from "react";

const useAuth = () => {
  const [loggedInUser, setLoggedInUser] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(null);

  useEffect(() => {
    const userData = localStorage.getItem("user");
    if (userData) {
      const parsedData = JSON.parse(userData);
      if (parsedData?.email) {
        setLoggedInUser(parsedData);
        setIsAuthenticated(true);
      }
    } else {
      setIsAuthenticated(false);
    }
  }, []);

  return { loggedInUser, isAuthenticated };
};

export default useAuth;
